import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { useMe } from '@/features/auth/api/get-me';
import { SignalRContext } from '@/providers/SignalRProvider';
import { useSettingsStore } from '@/stores/settingsStore';
import { Event } from '@/types';
import storage from '@/utils/storage';
import { Check, Search } from 'lucide-react';
import { useState } from 'react';

type SubEventListProps = {
  events: Event[];
};

export default function SubEventList({ events }: SubEventListProps) {
  const currentEventId = useSettingsStore(state => state.eventId);
  const breakoutId = useSettingsStore(state => state.breakoutId);
  const [searchQuery, setSearchQuery] = useState('');

  const setBreakoutId = useSettingsStore(state => state.setBreakoutId);

  const { data: user, isLoading: isLoadingMe } = useMe({
    config: {
      enabled: !!storage.getAccessToken(),
      refetchInterval: 1000 * 60 * 5, // 5 minutes,
    },
  });

  const handleSubEventChange = (eventId: number) => {
    setBreakoutId(eventId);
    SignalRContext.invoke('onsiteHandshake', {
      userGuid: user?.userGuid,
      eventId: eventId,
      ConnectionId: '123',
    });
  };

  const mainEvent = events.find(e => e.eventId === currentEventId)!;
  const subEvents = events
    .filter(event => event.parentEventId === currentEventId)
    .filter(event => (searchQuery ? event.eventId.toString().includes(searchQuery) || event.name.toLowerCase().includes(searchQuery.toLowerCase()) : true))
    .sort((a, b) => (a.eventId > b.eventId ? 1 : -1));

  return (
    <>
      <div className="relative w-full max-w-md mx-auto">
        <Search className="absolute left-3 w-5 h-5 top-1/2 transform -translate-y-3 text-muted-foreground" />
        <Input placeholder="Sök efter event-ID eller namn" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full mx-auto py-6 px-4 text-md mb-2 pl-10" />
      </div>
      <div className="w-full flex flex-col gap-2 overflow-y-auto ">
        <Card className="flex gap-4 items-center p-4 py-3" onClick={() => handleSubEventChange(mainEvent.eventId)}>
          <span className="truncate text-md">{`${mainEvent.eventId} - ${mainEvent.name}`}</span>
          <span className="text-sm text-muted-foreground">Huvudevent</span>
          {breakoutId === mainEvent.eventId ? <Check className="w-4 h-4 text-success" /> : null}
        </Card>
        {subEvents.length > 0 ? (
          subEvents.map(event => (
            <Card className="flex gap-4 items-center p-4 py-3" onClick={() => handleSubEventChange(event.eventId)} key={event.eventId}>
              <span className="truncate text-md">{event.name}</span>
              {breakoutId === event.eventId ? <Check className="w-4 h-4 text-success" /> : null}
            </Card>
          ))
        ) : (
          <div className="flex text-sm text-muted-foreground justify-center items-center p-4">Inga underaktiviteter tillgängliga för detta event.</div>
        )}
      </div>
    </>
  );
}
